import { performRequest } from "../performRequest"
import axios from 'axios';


export const getJobListApi = (params) => {
    return performRequest("get", "api/ess/job/",params)
}

export const createJobApi = (params) => {
    const company = localStorage.getItem('company') || 1

    params['company'] = company
    return performRequest("post", "api/ess/job/",params)
}

export const updateJobApi = (params, id) => {
    const company = localStorage.getItem('company') || 1

    params['company'] = company
    return performRequest("put", `api/ess/job/${id}/`,params)
}


export const getJobListPublicApi = (params) => {
    return performRequest("get", "api/ess/job/list/",params, false)
}


export const getJobDetailPublicApi = (slug, params) => {
    return performRequest("get", `/api/public/jobs/${slug}/`,params, false)
}


export const applyJobPublicApi = ( data) => {
    return performRequest("post", `/api/public/jobs/${data.job}/apply/`,data, false)
}

// Email verification API functions
export const sendEmailVerificationOTP = (data) => {
  return performRequest("post", "/api/public/email-verification/send-otp/", data, false);
};

export const verifyEmailOTP = (data) => {
  return performRequest("post", "/api/public/email-verification/verify-otp/", data, false);
};

export const resendEmailVerificationOTP = (data) => {
  return performRequest("post", "/api/public/email-verification/resend-otp/", data, false);
};


export const applyJobInternalApi = ( data) => {
  return performRequest("post", `/api/public/jobs/${data.job}/apply/`,data)
}